import styled from 'styled-components';
import Input from 'antd/es/input';

import Button from '@components/Button';
import { SearchBarInputStyles } from '@shared/searchBar/styled';

export const StyledNameFilter = styled.div`
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  & > * {
    box-sizing: border-box;
  }

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
`;

export const NameFilterTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-bottom: 4px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 0;
  }
`;

export const FilterHotelNameLabel = styled.span`
  display: block;
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGray};
`;

export const NameFilterInputWrapper = styled.div`
  width: 100%;
  height: 44px;
  padding: 0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.inputBackgroundColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border: solid 1px ${({ theme }) => theme.palette.inputBorderColor};

  .hidden {
    opacity: 0;
    visibility: hidden;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const NameFilterInput = styled(Input)`
  &&& {
    ${SearchBarInputStyles};
    width: 100%;
    min-height: 40px;
    padding: 8px 12px;
    align-items: center;

    background-color: transparent;

    .setur-input {
      background-color: transparent;
    }

    &:focus {
      box-shadow: none;
    }

    .setur-input-prefix {
      margin-inline-end: 12px;
      height: 20px;
    }
  }
`;

export const ClearContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  color: ${(p) => p.theme.palette.tomato};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const NameFilterSearchButton = styled(Button)`
  width: 100%;
  min-width: 100% !important;

  height: 100% !important;
  margin: 0;
  color: ${({ theme }) => theme.palette.tomato};
  font-weight: 900;
  font-size: 14px !important;
  border: solid 1px ${({ theme }) => theme.palette.tomato};
  border-radius: 8px;

  &:disabled {
    opacity: 0.5;
  }
`;

export const InputButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 54px;
  gap: 4px;
  grid-template-rows: 44px;
  margin-top: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
  }
`;

export const CollapsableStyledNameFilter = styled(StyledNameFilter)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 15px 15px 15px;
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const CollapsableNameFilterInputWrapper = styled(NameFilterInputWrapper)`
  margin-top: 0;
`;
